module.exports = __webpack_public_path__ + "static/media/chip-1000.c39dbbfe.png";